import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-filter-second-row-additional-content',
    template: `
    <ng-content></ng-content>
  `,
    standalone: true,
})
export class FilterSecondRowAdditionalContentComponent implements OnChanges, OnInit {

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnInit() {
    // console.log(this.optionsMap);
  }

}
